export { getCompanyPlanId } from './getComplanyPlanId';
